import * as React from "react";
const SvgStopCircle20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        viewBox: "0 0 18 18",
        fill: "black"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      d: "M5.794 5.85h6.412v6.3H5.794v-6.3Z"
    }),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18Zm7-9A7 7 0 1 1 2 9a7 7 0 0 1 14 0Z",
      clipRule: "evenodd"
    })
  );
export default SvgStopCircle20Px;
